export default "__VITE_ASSET__f005488b__"